import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
export const BaseButton = props => {
    const classes = classNames([
        'btn',
        props.icon ? 'btn-icon' : '',
        props.theme ? `btn-${props.theme}` : '',
        props.rounded ? 'btn-round' : '',
        props.className ? props.className : '',
        props.disabled ? 'disabled' : '',
    ]);
    return (_jsx("button", Object.assign({ className: classes, onClick: props.onClick, type: props.type, hidden: props.isHidden, "data-toggle": props.dataToggle, "data-target": props.dataTarget, "aria-expanded": props.ariaExpanded, "aria-controls": props.ariaControls, "data-testid": props.testid, disabled: props.disabled }, { children: props.children })));
};
